import React, { createContext, useMemo, useCallback } from 'react';
// import io from 'socket.io-client'; // ← COMENTADO: Conexão direta substituída por service centralizado
import KeyboardEventHandler from 'react-keyboard-event-handler';

import { useFight } from './Fight';

import { toLegacyFightId } from '../utils/legacyId';
import { sendAction } from '../services/actions/action-sender';
import { useKeys } from './ActionKeys';
const FightKeyContext = createContext({});

const FightKeyProvider: React.FC = ({ children }) => {
  const { updateFight, fight, getRoundTimeInSeconds } = useFight();
  const { isAnyModalOpen } = useKeys();

  const startTime = !fight.roundStatus || fight.roundStatus === 'paused';

  const emitTimeout = useCallback(async (type: string) => {
    const actionName = `timeout_${type}`;
    const recordData = {
      fightId: toLegacyFightId(fight.legacyId),
      fightNewId: fight.id,
      round: fight.currentRound,
      stance: fight.currentStance,
      domain: false,
      roundTime: getRoundTimeInSeconds(),
      name: actionName,
      corner: '',
      boutId: fight.oneFightId,
      eventId: fight.oneEventId || fight.eventId,
      authorId: fight.legacyRedCornerId,
      targetId: fight.legacyBlueCornerId,
      authorNewId: fight.redCornerId,
      targetNewId: fight.blueCornerId,
    };

    await sendAction('record', {
      promotionId: fight.promotionId,
      data: recordData,
    });
  }, [fight, getRoundTimeInSeconds]);

  const handleKeyEvent = useCallback((keyEvent: string, e: React.KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();
    // Mesmo bloqueio do ActionKeys: modal aberto, teclado inerte.
    if (isAnyModalOpen) return;

    // As teclas de domínio (3-5, 7-9) NÃO passam mais por aqui. `currentStance`
    // e `currentDomain` mudam juntos, num único handler, no ActionKeys.
    switch (keyEvent) {
      case 'enter':
        if (getRoundTimeInSeconds() === 0) {
          const recordData = {
            fightId: toLegacyFightId(fight.legacyId),
            fightNewId: fight.id,
            round: fight.currentRound,
            stance: 'standing',
            domain: null,
            corner: 'red',
            boutId: fight.oneFightId,
            eventId: fight.oneEventId || fight.eventId,
            roundTime: getRoundTimeInSeconds(),
            name: 'roundStart',
            authorId: fight.legacyRedCornerId,
            authorNewId: fight.redCornerId,
            targetId: fight.legacyBlueCornerId,
            targetNewId: fight.blueCornerId,
          };

          void sendAction('record', {
            promotionId: fight.promotionId,
            data: recordData,
          });
        }

        if (startTime) {
          updateFight({ roundStatus: 'started', status: 'live' });
        } else {
          updateFight({ roundStatus: 'paused' });
        }
        break;
      case 'space':
        if (startTime) {
          emitTimeout('end');
          updateFight({ roundStatus: 'started' });
        } else {
          emitTimeout('start');
          updateFight({ roundStatus: 'paused' });
        }

        break;
      case 'left':
        updateFight({ controlMode: !fight.controlMode });
        break;
      default:
    }
  }, [updateFight, fight, getRoundTimeInSeconds, startTime, emitTimeout, isAnyModalOpen]);

  const contextValue = useMemo(() => ({}), []);

  return (
    <>
      <KeyboardEventHandler
        handleKeys={['space', 'enter', 'left']}
        onKeyEvent={handleKeyEvent}
      />

      <FightKeyContext.Provider value={contextValue}>
        {children}
      </FightKeyContext.Provider>
    </>
  );
};

export default FightKeyProvider;
